"use client";

import React from "react";
import { RelatedContentSection } from "@/types/dto/destinations-page/destination-page-types";
import GenericLazyLoader from "@/components/common/generic-lazy-loader";

interface RelatedContentSectionProps {
  relatedContentSection: RelatedContentSection;
  moduleRankingPosition: number;
}

const LazyLoadRelatedContentSection = ({ relatedContentSection, moduleRankingPosition }: RelatedContentSectionProps) => 

    <GenericLazyLoader
      importComponent={() => import("./related-content-section")}
      componentProps={{ relatedContentSection, moduleRankingPosition }}
      debugName="Related Content Section"
      threshold={0.1}
      rootMargin="200px 0px"
    />;


export default LazyLoadRelatedContentSection;